
export default class Toggle{
	constructor(query) {
		var triggers = document.querySelectorAll(query + ':not([data-initialized])');

		[].forEach.call(triggers, this.setTriggers.bind(this));

		document.addEventListener('keydown', function(evt){
			if(evt.keyCode === 13 && this.activeElement !== document.body && this.activeElement.toggle) {
				$(this.activeElement).trigger('target.toggle', evt);
			}
		});
	}

	/**
	 * [setTriggers checks the current trigger for the data-persistent attribute and adds classes if it has that attribute]
	 * @param {[object]} trigger [the trigger element, which contains the data-persistent attribute]
	 * data-toggle-onleave
	 * data-toggle-onout
	 * data-toggle-persistent
	 * data-toggle-immediate
	 * data-toggle-closerelatives
	 * data-toggle-close
	 * data-toggle-noclose
	 */
	setTriggers(trigger) {

		var triggerParent = this.getParent(trigger),
			triggerTarget = this.getTarget(trigger, triggerParent);

		if (!triggerTarget) {
			return;
		}

		trigger.toggle = {};

		trigger.toggle.contentEl 		= triggerTarget;
		trigger.toggle.parentEl     	= triggerParent;
		trigger.toggle.activeClass 		= 'toggle--active';

		triggerTarget.toggle = {};

		triggerTarget.toggleContent = Toggle.toggle.bind(this, trigger);
		triggerTarget.showContent 	= Toggle.show.bind(this, trigger);
		triggerTarget.hideContent 	= Toggle.hide.bind(this, trigger);

		triggerTarget.afterContentHide  = triggerTarget.afterContentHide  || function() { return true; };
		triggerTarget.beforeUnsetOthers = triggerTarget.beforeUnsetOthers || function() { return true; };
		triggerTarget.beforeContentShow = triggerTarget.beforeContentShow || function() { return true; };
		triggerTarget.afterContentShow  = triggerTarget.afterContentShow  || function() { return true; };

		if (trigger.hasAttribute('data-toggle-persistent')) {
			triggerTarget.toggle.persistent = true;

			//This should only take place if data-toggle-persistent is set because otherwise it makes no sense to have it.
			if (trigger.hasAttribute('data-toggle-closerelatives')) {
				triggerTarget.toggle.relatives = trigger.getAttribute('data-toggle-closerelatives');
			}
		}

		if (trigger.hasAttribute('data-toggle-immediate')) {
			triggerTarget.showContent();
		}

		this.setHandlers(trigger);

		trigger.setAttribute('data-initialized', true);
	}

	setHandlers(trigger) {
		var self = this,
			evtType = trigger.getAttribute('data-toggle-event') || 'click';

		$(trigger).on(evtType + ' target.toggle', function(evt, relayedEvt) {
			//Check if the relayedEvt object contains the properties or methods we're going to use...
			//This is useful when 'target.toggle' is triggered through an external event and we need to use that other event's data.
			var canUseRelayed = relayedEvt && relayedEvt.type && relayedEvt.preventDefault && relayedEvt.stopImmediatePropagation,
				triggerEvt = canUseRelayed ? relayedEvt : evt,
				isTouchStart = triggerEvt.type === 'touchstart';

			if (this.nodeName === 'A' || isTouchStart) {
				triggerEvt.preventDefault();
			}

			Toggle.toggle.call(self, this, evt);

			if (isTouchStart) {
				triggerEvt.stopImmediatePropagation();
			}
		});
	}

	/**
	 * [getParent] Gets and returns the trigger's parent. If no parent selector is set with data-parent it will default to parentNode
	 * @param  {[object]} trigger [the target trigger]
	 * @return {[object]}         [trigger's target parent]
	 */
	getParent(trigger) {
		return document.querySelector(trigger.getAttribute('data-toggle-parent')) || trigger.parentNode;
	}

	/**
	 * [getTarget] Gets and returns the trigger's content. If there are more than one matching content
	 * the method will return the trigger's parent content.
	 * @param  {[object]} trigger       [the target trigger]
	 * @return {[object]}               [the targeted content]
	 */
	getTarget(trigger, triggerParent) {
		var contentSelector = trigger.getAttribute('data-toggle-target'),
			contentEl = document.querySelectorAll(contentSelector);

		if (!contentEl.length) {
			console.warn('No content target (data-toggle-target) provided or element not found for: ', trigger);

			return;
		}

		return contentEl.length > 1 ? triggerParent.querySelector(contentSelector) : contentEl[0];
	}

	/**
	 * [hide] hides the target content and removes events from the body
	 * @param  {[object]} trigger
	 */
	static hide(trigger) {
		Toggle.$body = Toggle.$body || $('body');
		
		var triggerOptions = trigger.toggle,
			triggerTarget = triggerOptions.contentEl;

		trigger.classList.remove(triggerOptions.activeClass);
		triggerOptions.parentEl.classList.remove(triggerOptions.activeClass);
		triggerTarget.classList.remove(triggerOptions.activeClass);

		if (triggerOptions.pointerTouchEvt) {
			Toggle.$body.off('.' + trigger.getAttribute('data-toggle-target'));
		}

		triggerTarget.afterContentHide(trigger);
	}

	/**
	 * [show description]
	 * beforeContentShow, afterContentShow are fired here
	 * 
	 * @param  {[type]} trigger [description]
	 * @param  {[type]} evtType [description]
	 * @return {[type]}         [description]
	 */
	static show(trigger, evtType) {

		Toggle.$body = Toggle.$body || $('body');

		var triggerEvt = evtType || '',
			triggerTarget = trigger.toggle.contentEl,
			triggerParent = trigger.toggle.parentEl;

		if(triggerTarget.beforeContentShow(trigger)){

			if( triggerTarget.beforeUnsetOthers() ){
				Toggle.unsetActive(trigger.toggle.activeClass, triggerTarget.toggle.relatives);
			}

			trigger.classList.add(trigger.toggle.activeClass);
			triggerParent.classList.add(trigger.toggle.activeClass);
			triggerTarget.classList.add(trigger.toggle.activeClass);

			triggerTarget.afterContentShow(trigger);

			//If the current trigger doesn't have the data-toggle-onout, toggle (attach) a hide click event to the body
			//to hide the content if the users clicks outside the trigger or its content.
			if (!trigger.getAttribute('data-toggle-onout')) {
				var bodyEvtType = triggerEvt.indexOf('touch') >= 0 ? triggerEvt : 'click';
				//Attach this property to determine if we should remove the click event from the body after it's being executed.
				trigger.toggle.pointerTouchEvt = bodyEvtType + '.' + trigger.getAttribute('data-toggle-target');

				$('body').off('.' + trigger.getAttribute('data-toggle-target')).on(trigger.toggle.pointerTouchEvt, function(evt) {

					var $target = $(evt.target),
						$closestParent = $target.closest(triggerParent),
						$closestContent = $target.closest(triggerTarget);

					// if(!$target.closest('.toggle--active').length){
					// This is also ugly, but it works. The reason we check for parent AND content length is
					// cause sometimes the parent does not contain the content, but only the trigger
					if (!$closestContent.length && !$closestParent.length && $target[0] !== trigger) {
						// console.log('click', trigger);
						triggerTarget.hideContent();
					}

				});
			}

			//Hide content on hover out
			if (trigger.hasAttribute('data-toggle-onleave')) {
				var $triggerParent = $(triggerParent);

				$triggerParent.on('mouseleave.hideOnLeave', function() {
					$triggerParent.off('mouseleave.hideOnLeave');
					triggerTarget.hideContent();
				});
			}

			//Toggles the content off after 'data-toggle-timeout' has elapsed
			if (trigger.hasAttribute('data-toggle-timeout')) {
				window.setTimeout(triggerTarget.hideContent, trigger.getAttribute('data-toggle-timeout'));
			}

			//This is very ugly, but it works.
			var closeTargets = triggerTarget.querySelectorAll('[data-toggle-close]');

			[].forEach.call(closeTargets, function(closeEl) {
				$(closeEl).off('click.closeContent').on('click.closeContent', triggerTarget.hideContent);
			});
		}
	}

	/**
	 * [toggle] determines wether it should display or hide the content.
	 * Gets the current active triggers and removes their active classes.
	 * @param  {[object]} trigger [trigger which has the target content and parent]
	 */
	static toggle(trigger, evt) {
		var triggerTarget = trigger.toggle.contentEl,
			evtType = evt ? evt.type : '';

		if (triggerTarget.classList.contains(trigger.toggle.activeClass)) {
			if (!trigger.hasAttribute('data-toggle-noclose') && evtType !== 'mouseenter') {
				triggerTarget.hideContent();
			}
		}

		else {
			Toggle.show(trigger, evtType);
			if(trigger.hasAttribute('data-toggle-scrollup')) {
				var scrollTarget = trigger.getAttribute('data-toggle-scrollup');
				if(scrollTarget && $(scrollTarget).length > 0) {
					$('html, body').animate({
				        scrollTop: $(scrollTarget).offset().top
				    }, 1000);
				}
			}
		}
		
	}

	/**
	 * Unsets all active items. Unless the item has the data-toggle-persistent attribute (but if it has data-toggle-persistent AND data-toggle-closerelatives the the relatives will be closed)
	 */
	static unsetActive(activeClass, relatives) {
		var activeTriggers = document.querySelectorAll('.' + activeClass + ':not([data-toggle-target])');

		Array.prototype.forEach.call(activeTriggers, function(activeItem) {
			if (activeItem.toggle && (!activeItem.toggle.persistent || activeItem.classList.contains(relatives) ) && activeItem.hideContent) {
				activeItem.hideContent();
			}
		});
	}
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.toggle.js